
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/workspaces",
      function () {
        return require("private-next-pages/workspace-management/workspaces.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/workspaces"])
      });
    }
  